// includes every matching pool by Id to be displayed in the PoolCard and Pool id page
export const elegibleGG23pools = [559, 563, 849, 131, 132, 48, 49];
